import ConfigFile from "../../../datasets/config_file";

export const processLastCardEvents = (beforeGameData, eventObj) => {
             
    let returnTable = [];
    let totalCashChange = 0;
    let cashAmount = JSON.parse(JSON.stringify(beforeGameData.beforeCash));
    console.log('************************************************')
    console.log("starting cash amount: ", cashAmount);
    if (eventObj.creditCardActive === false){
        totalCashChange = +beforeGameData.totalAssets - +beforeGameData.totalExpenses -
            +beforeGameData.totalLoans;
    }else{
        //  note... the following will not work when nbr months per turn is not 1....
        //  may need to use an array for assets, expenses and loans ...  (entry for each month)
        totalCashChange = +beforeGameData.totalAssets - +eventObj.nonCreditCardExpenses -
            +beforeGameData.totalLoans;
    }
    
    console.log("total cash change: ", totalCashChange);
    cashAmount = (+cashAmount + +totalCashChange).toFixed(2);
    console.log("after total cash change (monthly income) added: ", cashAmount)
    let savingsAmount = 0;
    if (eventObj.savingsDeposit ){
        savingsAmount = +eventObj.savingsDeposit * +eventObj.monthsPerTurn;
    }
    cashAmount = (cashAmount - savingsAmount).toFixed(2);
    console.log("after savings taken out: ", cashAmount);
    if (eventObj.creditCardMinPayment ){
        cashAmount = (+cashAmount - +eventObj.creditCardMinPayment).toFixed(2);
    }
    console.log("after credit card minimum payment: ", cashAmount, " minimum payment: ", eventObj.creditCardMinPayment);
   
    if (eventObj.creditCardActive === false){
        //  livingExpense is the amount difference between the old Misc -food, etc. and current
        //  it is zero unless last card was "Spending Habits"
        cashAmount = (+cashAmount + +eventObj.livingExpense).toFixed(2);
    }
    // if tax amount has been changed in the current month, the increase/decrease will be in the taxChangeAmt
    //cashAmount = (+cashAmount + +eventObj.taxChangeAmt).toFixed(2);
    cashAmount = cashAmount.toString();
    console.log("final cashAmount: ", cashAmount, "living expense chg: ", eventObj.livingExpense);

    const fullMoodPointChg = (+eventObj.moodPoints * +ConfigFile.gameBoard.moodPointMultiplier).toFixed(0);
    const totalMoodPoints = +beforeGameData.beforeMoodPoints + +fullMoodPointChg; 
    const cashMoodObj = {subProcess: eventObj.title, cash: cashAmount, 
        moodPoints: totalMoodPoints};
    returnTable.push(cashMoodObj);

     //  ---  note:  need to change gameBoard to put in expire table if within nbr months per turn
     //  AND...  add nbr months until expire into the expire table ....  the calculation below
     //  only works when monthsPerTurn is 1.

    let totalAssets = JSON.parse(JSON.stringify(beforeGameData.totalAssets));
    let totalExpenses = JSON.parse(JSON.stringify(beforeGameData.totalExpenses));
    let totalLoans = JSON.parse(JSON.parse(JSON.stringify(beforeGameData.totalLoans)));

    //  livingExpense is 0 unless the last card was a 'Spending Habits' and the player chooses
    //  an option that has a different level (amount) of living expenses
    totalExpenses = (+totalExpenses - +eventObj.livingExpense).toFixed(2);
    console.log("totalExpenses is: ", totalExpenses);
    let expireTableExpenseFound = false;
    for (let i=0; i<eventObj.expireTable.length; i++){
        let expireObj = eventObj.expireTable[i];
        switch (expireObj.tableType){
            case "asset":
                totalAssets = (+totalAssets - +expireObj.tableAmt).toFixed(2);
                const assetObj = {tableType: "asset", newTableTotal: totalAssets, process: "LastCard",
                    subProcess: eventObj.title};
                returnTable.push(assetObj);
                break;
            case "expense":
                expireTableExpenseFound = true;
                totalExpenses = (+totalExpenses - +expireObj.tableAmt).toFixed(2);
                const expenseObj = {tableType: "expense", newTableTotal: totalExpenses, process: "LastCard",
                    subProcess: eventObj.title};
                returnTable.push(expenseObj);
                break;
            case "loan":
                totalLoans = (+beforeGameData.totalLoans - +expireObj.tableAmt).toFixed(2);
                const loanObj = {tableType: "loan", newTableTotal: totalLoans, process: "LastCard",
                    subProcess: eventObj.title};
                returnTable.push(loanObj);
                break;
            default:
                break;
        }
    }
    if (expireTableExpenseFound === false){  
        const expenseObj = {tableType: "expense", newTableTotal: totalExpenses, process: "LastCard",
            subProcess: eventObj.title}
            returnTable.push(expenseObj);
    }

    return returnTable;
}

export default processLastCardEvents;